<template>
    <Panel class="inventoryUsagePanel" :title="$t('usage.view')" :collapsed="!preload" collapsible
           icon="icon/faq.svg" @opened="loadUsage" :class="[type]">
        <template v-if="loaded && usage">

            <template v-if="type === 'item' || type === 'category'">
                <div class="description">{{$t('usage.available_in_catalog_' + type)}}</div>
                <br>
                <div class="tags">
                  <Tag v-for="(c,i) of catalogs" :key="`usage_${id}_${i}`">{{$to(c) || $t(`catalog.${c}`)}}</Tag>
                </div>
                <div class="empty" v-if="catalogs.length === 0">{{$t(`usage.no_catalog_${type}`)}}</div>
            </template>

            <template v-if="type === 'modifier'">
                <div class="empty" v-if="usage.modifierOf.length === 0 && usage.inModifierGroups.length === 0">
                    {{$t('usage.modifier_not_used')}}
                </div>
                <table>
                    <tr v-for="item of usage.modifierOf" :key="'item' + item.id" @click="openItem(item)">
                        <td class="type">
                            <Tag>{{$t(item.type)}}</Tag>
                        </td>
                        <td class="name" colspan="2">
                            <template v-if="item.parent">{{$to(item.parent.name)}} - </template>{{$to(item.name)}}
                        </td>
                        <td class="action">
                            <div class="link">
                                {{$t('view')}}<svgicon src="icon/link.svg" :height="13" :width="13"></svgicon>
                            </div>
                        </td>
                    </tr>
                    <template v-for="modifierGroup of usage.inModifierGroups">
                        <tr class="modifier-group" @click="openModifierGroup(modifierGroup)">
                            <td class="type">
                                <Tag grey>{{$t("modifier_group")}}</Tag>
                            </td>
                            <td class="name" colspan="2">
                                {{$to(modifierGroup.name)}}
                            </td>
                            <td class="action">
                                <div class="link">
                                    {{$t('view')}}<svgicon src="icon/link.svg" :height="13" :width="13"></svgicon>
                                </div>
                            </td>
                        </tr>
                        <tr class="subitem" v-for="item of modifierGroup.usedInItems" :key="'modifier-group-item' + item.id" @click="openItem(item)">
                            <td></td>
                            <td class="type">
                                <Tag>{{$t(item.type)}}</Tag>
                            </td>
                            <td class="name">
                                <template v-if="item.parent">{{$to(item.parent.name)}} - </template>{{$to(item.name)}}
                            </td>
                            <td class="action">
                                <div class="link">
                                    {{$t('view')}}<svgicon src="icon/link.svg" :height="13" :width="13"></svgicon>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="modifierGroup.usedInItems.length === 0" class="no-item">
                            <td class="type"></td>
                            <td class="name" colspan="2">{{$t('usage.modifier_group_no_items')}}</td>
                            <td></td>
                        </tr>
                    </template>
                </table>
            </template>

            <template v-if="type === 'choice-item'">
                <div class="empty" v-if="usage.inChoices.length === 0 && usage.inChoiceGroups.length === 0">
                    {{$t('usage.choice_item_not_used')}}
                </div>
                <table>
                <template v-for="choice of usage.inChoices">
                    <tr class="modifier-group" @click="openChoice(choice)">
                        <td class="type">
                            <Tag grey>{{$t("choice")}}</Tag>
                        </td>
                        <td class="name" colspan="2">
                            {{$to(choice.name)}}
                        </td>
                        <td class="action">
                            <div class="link">
                                {{$t('view')}}<svgicon src="icon/link.svg" :height="13" :width="13"></svgicon>
                            </div>
                        </td>
                    </tr>
                    <tr class="subitem" v-for="item of choice.usedInItems" :key="'choice-item' + item.id" @click="openItem(item)">
                        <td></td>
                        <td class="type">
                            <Tag>{{$t(item.type)}}</Tag>
                        </td>
                        <td class="name">
                            <template v-if="item.parent">{{$to(item.parent.name)}} - </template>{{$to(item.name)}}
                        </td>
                        <td class="action">
                            <div class="link">
                                {{$t('view')}}<svgicon src="icon/link.svg" :height="13" :width="13"></svgicon>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="choice.usedInItems.length === 0" class="no-item">
                        <td class="type"></td>
                        <td class="name" colspan="2">{{$t('usage.choice_no_items')}}</td>
                        <td></td>
                    </tr>
                </template>
                </table>
            </template>

            <template v-if="type === 'choice' || type === 'modifier-group'">
                <div class="empty" v-if="usage.usedInItems.length === 0 && usage.usedInItems.length === 0">
                    {{type === 'choice' ? $t('usage.choice_no_items') : $('usage.modifier_group_no_items')}}
                </div>
                <table>
                    <tr v-for="item of usage.usedInItems" :key="'item' + item.id" @click="openItem(item)">
                        <td class="type">
                            <Tag>{{$t(item.type)}}</Tag>
                        </td>
                        <td class="name" colspan="2">
                            <template v-if="item.parent">{{$to(item.parent.name)}} - </template>{{$to(item.name)}}
                        </td>
                        <td class="action">
                            <div class="link">
                                {{$t('view')}}<svgicon src="icon/link.svg" :height="13" :width="13"></svgicon>
                            </div>
                        </td>
                    </tr>
                </table>
            </template>
        </template>
    </Panel>
</template>

<script>
    import Tag from "@/components/tools/Tag.vue";
    import {mapActions} from "vuex";

    export default {
      name: "InventoryUsagePanel",

      components: { Tag },

      props: {
        type: String,
        id: String|Number,
        preload: Boolean,
        element: Object
      },

      async mounted() {
        this.inventory = await this.$store.getters.getContextInventory;

        if (this.preload) {
          this.loadUsage();
        }
      },

      data() {
        return {
          usage: null,
          loaded: false,
          inventory: null
        }
      },

      computed: {
        inventoryReference() {
          return this.$store.state.contextCompany ? this.$store.state.contextCompany.nameCanonical : this.inventory.id;
        },
        catalogs() {
          let catalogs = {};
          for (let entity of [...this.usage.inCategories || [], ...this.usage.containsItems || []]) {
            for (let catalog of entity.catalogs) {
              catalogs[JSON.stringify(catalog)] = catalog
            }
          }
          return Object.values(catalogs);
        }
        //TODO load properly for type category
      },

      methods: {
        ...mapActions(["getItemUsage"]),

        openItem(item) {
          let route = this.$router.resolve(this.$router.buildContext("/item/edit", {item: item.parent ? item.parent.id : item.id}));
          window.open(route.href, "_blank");
        },

        openModifierGroup(modifierGroup) {
          let route = this.$router.resolve(this.$router.buildContext("/modifier-groups/edit", {id : modifierGroup.id}));
          window.open(route.href, "_blank");
        },

        async loadUsage() {
          if (this.loaded) {
            return;
          }
          let response = await this.getItemUsage({inventory: this.inventoryReference, id: this.id, type: this.type});
          if (response) {
            this.loaded = true;
            this.usage = response;
          }
          this.loaded = true;
        }
      }
    }
</script>

<style lang="scss" scoped>
    .tag {
        font-weight: normal;
        text-align: center;
        text-transform: none;
        white-space: nowrap;
        padding: 4px 10px;
    }
    .empty {
        font-weight: bold;
    }
    .item, .category {
        .tag:not(:last-child) {
            margin-right: 10px;
        }
    }
    table .tag {
        width: 100%;
        padding: 4px 12px;
    }
    .subitem {
        td:nth-child(2) {
            padding-left: 15px;
        }
    }
    .name {
        width: 100%;
        transition: font-weight 150ms linear;
        padding: 0 15px;
    }
    tr {
        &:not(.no-item) {
            cursor: pointer;
            &:hover {
                .name {
                    font-weight: bold;
                }
            }
        }

        &:not(.modifier-group):not(:last-child) {
            border-bottom: 1px dashed #e6e6e6;
        }
    }
    .no-item {
        td {
            height: 35px;
            padding-bottom: 15px;
        }
    }
    td {
        $padding: 10px;
        height: 46px;
        padding-top: $padding;
        padding-bottom: $padding;
        .link {
            display: flex;
            align-items: center;
            color: var(--primary-color);
            font-weight: 500;
        }
        .svgicon {
            margin-right: 0;
            margin-left: 5px;
        }
    }
    .no-item {
        font-style: italic;
        opacity: 0.6;
    }
    .btn {
        padding: 4px 10px;
    }

    @media screen and (max-width: 720px) {
        .tag {
            font-size: 12px;

        }
    }
</style>

<style lang="scss">
    .inventoryUsagePanel .content .content-inner {
        padding-top: 20px;
        overflow-y: auto;
        max-height: 650px;
    }
    @media screen and (max-width: 720px) {
        .inventoryUsagePanel .tag {
            white-space: initial;
        }
        .inventoryUsagePanel .content .content-inner {
            padding-top: 15px;
        }
    }
</style>